import React, { useEffect } from 'react'

const SearchInput = ({
  keyword,
  amap,
  AMap,
  setCenter,
  locationName,
  updateLocationName,
  addMarkerEvent,
}) => {
  const searchEvent = () => {
    // Autocomplete 输入提示插件
    // PlaceSearch POI搜索插件
    const autoOptions = {
      city: '全国',
      input: keyword,
    }

    // 自动在页面相应的表单控件上监听输入并显示匹配结果
    const autoComplete = new AMap.AutoComplete(autoOptions)
    const placeSearch = new AMap.PlaceSearch({
      city: '全国',
      renderStyle: 'newpc',
      autoFitView: true,
    })
    AMap.Event.addListener(autoComplete, 'select', (e) => {
      placeSearch.setCity(e.poi.adcode)
      placeSearch.search(e.poi.name)
    })
    AMap.Event.addListener(autoComplete, 'error', () => {
      console.log('input搜索查询失败')
    })

    AMap.Event.addListener(placeSearch, 'complete', ({ poiList }) => {
      const { pois } = poiList
      if (pois.length > 0) {
        // 获取第一个点
        const { location } = pois[0]
        const { lat, lng } = location
        setCenter([lng, lat])
        addMarkerEvent(pois[0], true)
      }
    })
  }

  useEffect(() => {
    if (amap) {
      searchEvent()
    }
  }, [amap])

  return (
    <div
      className="w-1/3 absolute top-4 left-4 flex flex-row items-center"
      style={{ zIndex: '100' }}
    >
      <input
        id={keyword}
        name={keyword}
        type="text"
        value={locationName || ''}
        className="form-input w-full pr-8 border-none"
        style={{
          boxShadow: '0 1px 10px -1px rgba(0,0,0,0.10)',
          fontSize: '0.8175rem',
        }}
        onChange={(e) => {
          updateLocationName(e.target.value)
        }}
      />
    </div>
  )
}

export default SearchInput
